import { apiFetch } from '../config/api'

export type ProjectHubViewMode = 'card' | 'list'

export interface UserPreferences {
  projectHub?: { viewMode?: ProjectHubViewMode }
}

export async function fetchUserPreferences(): Promise<UserPreferences> {
  return apiFetch<UserPreferences>('/api/users/me/preferences')
}

export async function patchUserPreferences(
  patch: Partial<UserPreferences>
): Promise<UserPreferences> {
  return apiFetch<UserPreferences>('/api/users/me/preferences', {
    method: 'PATCH',
    body: JSON.stringify(patch)
  })
}
